import {
  Box,
  Button,
  ButtonAppearance,
  ButtonSize,
  Heading,
  Icon,
  IconSize,
  ModalBody,
  Text,
  useModalState,
} from '@bechtel/gds';
import { Question } from '@bechtel/sr-types';
import { findIndex } from 'lodash';
import { FC, useRef, useState } from 'react';
import { MultiLingualText } from '~/components/atoms';
import { ItemStyled, ModalHeaderStyled, ModalStyled, TextStyled } from '../styled';
import { LayoutButtonStyled, MessageTypeStyled } from './styled';
import { QuestionModalProps, QuestionModalResponse } from './types';

export const QuestionModal: FC<QuestionModalProps> = ({ messages, onSubmit, dismissIndex }) => {
  const { visible, close } = useModalState(true);
  const [currentStep, setCurrentStep] = useState(0);

  const questionResponseRef = useRef<QuestionModalResponse[]>([]);
  const currentQuestion = messages[currentStep];

  const canCancel = findIndex(currentQuestion?.buttons, (btn) => btn === 'Cancel') != -1;
  const hasYesOption = findIndex(currentQuestion?.buttons, (btn) => btn === 'Yes') != -1;
  const hasNoOption = findIndex(currentQuestion?.buttons, (btn) => btn === 'No') != -1;

  const onClickHandler = (response: Question) => {
    questionResponseRef.current.push({
      messageKey: currentQuestion?.messageKey,
      response: response,
    });
    if (dismissIndex === currentStep && response === Question.REPLY_NO) {
      close();
    } else {
      setCurrentStep(currentStep + 1);

      if (currentStep + 1 === messages.length) {
        onSubmit(questionResponseRef.current);
      }
    }
  };

  return (
    <ModalStyled visible={visible}>
      <ModalHeaderStyled title="">
        <Box alignItems={{ sm: 'center' }} flexGrow={{ sm: 1 }}>
          <MessageTypeStyled>
            <Icon icon="circle-question" iconStyle="solid" fillColor="white" size={IconSize.MEDIUM} />
          </MessageTypeStyled>
          <Box pl={{ sm: '300' }}>
            <Heading size="500" weight="500">
              <MultiLingualText textKey="QUESTION"></MultiLingualText>
            </Heading>
          </Box>
          <Box css={{ marginLeft: 'auto' }}>
            {canCancel && (
              <Box alignItems={{ sm: 'center' }} p={{ sm: '400' }}>
                <Button
                  size={ButtonSize.SMALL}
                  css={{ background: 'transparent', boxShadow: 'none' }}
                  onClick={() => {
                    close();
                  }}
                >
                  <Icon icon="times" iconStyle="regular" size={IconSize.LARGE} />
                </Button>
              </Box>
            )}
          </Box>
        </Box>
      </ModalHeaderStyled>
      {/* @ts-ignore adjust in GDS component to take child as prop  */}
      <ModalBody
        css={`
          flex-direction: column;
        `}
      >
        <ItemStyled>
          <TextStyled size="500">{currentQuestion?.messageText}</TextStyled>
        </ItemStyled>
        <Box p={{ sm: '450' }} alignItems={{ sm: 'center' }} css={{ marginTop: 'auto' }}>
          <Text size="400">
            {currentStep + 1}/{messages.length}
          </Text>
          <Box css={{ marginLeft: 'auto' }}>
            {hasYesOption && (
              <LayoutButtonStyled
                appearance={ButtonAppearance.PRIMARY}
                onClick={() => {
                  onClickHandler(Question.REPLY_YES);
                }}
              >
                <MultiLingualText>Yes</MultiLingualText>
              </LayoutButtonStyled>
            )}
            {hasNoOption && (
              <LayoutButtonStyled
                appearance={ButtonAppearance.SECONDARY}
                onClick={() => {
                  onClickHandler(Question.REPLY_NO);
                }}
              >
                <MultiLingualText>No</MultiLingualText>
              </LayoutButtonStyled>
            )}
          </Box>
        </Box>
      </ModalBody>
    </ModalStyled>
  );
};
